// numeral.js
// version : 1.4.5
// author : Adam Draper
// license : MIT
// http://adamwdraper.github.com/Numeral-js/
(function() {
    function o(e) {
        this._n = e
    }

    function u(e, t, n) {
        var r = Math.pow(10, t),
            i;
        i = (Math.round(e * r) / r).toFixed(t);
        if (n) {
            var s = new RegExp("0{1," + n + "}$");
            i = i.replace(s, "")
        }
        return i
    }

    function a(e, t) {
        var n;
        t.indexOf("$") > -1 ? n = l(e, t) : t.indexOf("%") > -1 ? n = c(e, t) : t.indexOf(":") > -1 ? n = h(e, t) : n = d(e, t);
        return n
    }

    function f(e, t) {
        if (t.indexOf(":") > -1) e._n = p(t);
        else if (t === i) e._n = 0;
        else {
            var s = t;
            n[r].delimiters.decimal !== "." && (t = t.replace(/\./g, "").replace(n[r].delimiters.decimal, "."));
            var o = new RegExp(n[r].abbreviations.thousand + "(?:\\)|(\\" + n[r].currency.symbol + ")?(?:\\))?)?$"),
                u = new RegExp(n[r].abbreviations.million + "(?:\\)|(\\" + n[r].currency.symbol + ")?(?:\\))?)?$"),
                a = new RegExp(n[r].abbreviations.billion + "(?:\\)|(\\" + n[r].currency.symbol + ")?(?:\\))?)?$"),
                f = new RegExp(n[r].abbreviations.trillion + "(?:\\)|(\\" + n[r].currency.symbol + ")?(?:\\))?)?$"),
                l = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
                c = !1;
            for (var h = 0; h <= l.length; h++) {
                c = t.indexOf(l[h]) > -1 ? Math.pow(1024, h + 1) : !1;
                if (c) break
            }
            e._n = (c ? c : 1) * (s.match(o) ? Math.pow(10, 3) : 1) * (s.match(u) ? Math.pow(10, 6) : 1) * (s.match(a) ? Math.pow(10, 9) : 1) * (s.match(f) ? Math.pow(10, 12) : 1) * (t.indexOf("%") > -1 ? .01 : 1) * Number((t.indexOf("(") > -1 ? "-" : "") + t.replace(/[^0-9\.'-]+/g, ""));
            e._n = c ? Math.ceil(e._n) : e._n
        }
        return e._n
    }

    function l(e, t) {
        var i = t.indexOf("$") <= 1 ? !0 : !1,
            s = "";
        if (t.indexOf(" $") > -1) {
            s = " ";
            t = t.replace(" $", "")
        } else if (t.indexOf("$ ") > -1) {
            s = " ";
            t = t.replace("$ ", "")
        } else t = t.replace("$", "");
        var o = a(e, t);
        if (i)
            if (o.indexOf("(") > -1 || o.indexOf("-") > -1) {
                o = o.split("");
                o.splice(1, 0, n[r].currency.symbol + s);
                o = o.join("")
            } else o = n[r].currency.symbol + s + o;
            else if (o.indexOf(")") > -1) {
            o = o.split("");
            o.splice(-1, 0, s + n[r].currency.symbol);
            o = o.join("")
        } else o = o + s + n[r].currency.symbol;
        return o
    }

    function c(e, t) {
        var n = "";
        if (t.indexOf(" %") > -1) {
            n = " ";
            t = t.replace(" %", "")
        } else t = t.replace("%", "");
        e._n = e._n * 100;
        var r = a(e, t);
        if (r.indexOf(")") > -1) {
            r = r.split("");
            r.splice(-1, 0, n + "%");
            r = r.join("")
        } else r = r + n + "%";
        return r
    }

    function h(e, t) {
        var n = Math.floor(e._n / 60 / 60),
            r = Math.floor((e._n - n * 60 * 60) / 60),
            i = Math.round(e._n - n * 60 * 60 - r * 60);
        return n + ":" + (r < 10 ? "0" + r : r) + ":" + (i < 10 ? "0" + i : i)
    }

    function p(e) {
        var t = e.split(":"),
            n = 0;
        if (t.length === 3) {
            n += Number(t[0]) * 60 * 60;
            n += Number(t[1]) * 60;
            n += Number(t[2])
        } else if (t.lenght === 2) {
            n += Number(t[0]) * 60;
            n += Number(t[1])
        }
        return Number(n)
    }

    function d(e, t) {
        var s = !1,
            o = !1,
            a = "",
            f = "",
            l = "",
            c = Math.abs(e._n);
        if (e._n === 0 && i !== null) return i;
        if (t.indexOf("(") > -1) {
            s = !0;
            t = t.slice(1, -1)
        }
        if (t.indexOf("a") > -1) {
            if (t.indexOf(" a") > -1) {
                a = " ";
                t = t.replace(" a", "")
            } else t = t.replace("a", ""); if (c >= Math.pow(10, 12)) {
                a += n[r].abbreviations.tillion;
                e._n = e._n / Math.pow(10, 12)
            } else if (c < Math.pow(10, 12) && c >= Math.pow(10, 9)) {
                a += n[r].abbreviations.billion;
                e._n = e._n / Math.pow(10, 9)
            } else if (c < Math.pow(10, 9) && c >= Math.pow(10, 6)) {
                a += n[r].abbreviations.million;
                e._n = e._n / Math.pow(10, 6)
            } else if (c < Math.pow(10, 6) && c >= Math.pow(10, 3)) {
                a += n[r].abbreviations.thousand;
                e._n = e._n / Math.pow(10, 3)
            }
        }
        if (t.indexOf("b") > -1) {
            if (t.indexOf(" b") > -1) {
                f = " ";
                t = t.replace(" b", "")
            } else t = t.replace("b", "");
            var h = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
                p, d;
            for (var v = 0; v <= h.length; v++) {
                p = Math.pow(1024, v);
                d = Math.pow(1024, v + 1);
                if (e._n >= p && e._n < d) {
                    f += h[v];
                    p > 0 && (e._n = e._n / p);
                    break
                }
            }
        }
        if (t.indexOf("o") > -1) {
            if (t.indexOf(" o") > -1) {
                l = " ";
                t = t.replace(" o", "")
            } else t = t.replace("o", "");
            l += n[r].ordinal(e._n)
        }
        if (t.indexOf("[.]") > -1) {
            o = !0;
            t = t.replace("[.]", ".")
        }
        var m = e._n.toString().split(".")[0],
            g = t.split(".")[1],
            y = t.indexOf(","),
            b = "",
            w = !1;
        if (g) {
            if (g.indexOf("[") > -1) {
                g = g.replace("]", "");
                g = g.split("[");
                b = u(e._n, g[0].length + g[1].length, g[1].length)
            } else b = u(e._n, g.length);
            m = b.split(".")[0];
            b.split(".")[1].length ? b = n[r].delimiters.decimal + b.split(".")[1] : b = "";
            o && Number(b) === 0 && (b = "")
        } else m = u(e._n, null); if (m.indexOf("-") > -1) {
            m = m.slice(1);
            w = !0
        }
        y > -1 && (m = m.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + n[r].delimiters.thousands));
        t.indexOf(".") === 0 && (m = "");
        return (s && w ? "(" : "") + (!s && w ? "-" : "") + m + b + (l ? l : "") + (a ? a : "") + (f ? f : "") + (s && w ? ")" : "")
    }

    function v(e, t) {
        n[e] = t
    }
    var e, t = "1.4.5",
        n = {}, r = "en",
        i = null,
        s = typeof module != "undefined" && module.exports;
    e = function(t) {
        e.isNumeral(t) ? t = t.value() : Number(t) || (t = 0);
        return new o(Number(t))
    };
    e.version = t;
    e.isNumeral = function(e) {
        return e instanceof o
    };
    e.language = function(t, i) {
        if (!t) return r;
        t && !i && (r = t);
        (i || !n[t]) && v(t, i);
        return e
    };
    e.language("en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(e) {
            var t = e % 10;
            return~~ (e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th"
        },
        currency: {
            symbol: "$"
        }
    });
    e.zeroFormat = function(e) {
        typeof e == "string" ? i = e : i = null
    };
    e.fn = o.prototype = {
        clone: function() {
            return e(this)
        },
        format: function(t) {
            return a(this, t ? t : e.defaultFormat)
        },
        unformat: function(t) {
            return f(this, t ? t : e.defaultFormat)
        },
        value: function() {
            return this._n
        },
        valueOf: function() {
            return this._n
        },
        set: function(e) {
            this._n = Number(e);
            return this
        },
        add: function(e) {
            this._n = this._n + Number(e);
            return this
        },
        subtract: function(e) {
            this._n = this._n - Number(e);
            return this
        },
        multiply: function(e) {
            this._n = this._n * Number(e);
            return this
        },
        divide: function(e) {
            this._n = this._n / Number(e);
            return this
        },
        difference: function(e) {
            var t = this._n - Number(e);
            t < 0 && (t = -t);
            return t
        }
    };
    s && (module.exports = e);
    typeof ender == "undefined" && (this.numeral = e);
    typeof define == "function" && define.amd && define([], function() {
        return e
    })
}).call(this);